import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable, WithChildren } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

export type FormSectionProps = ExtendableStyles &
  Testable &
  WithChildren & {
    title: string
    subtitle?: string
  }

export function FormSection({ className, style, children, title, subtitle, ...otherProps }: FormSectionProps) {
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.formSection)} style={style} {...otherProps}>
      <Typography variant="h6">{title}</Typography>
      {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      <div className={classes.formContent}>{children}</div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  formSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  formContent: {
    marginTop: spacing(2),
  },
}))
